import {
  NoticeCategoryEntity,
} from './noticeCategoryEntity';
import { Category } from './valueObjects/category';
import { CategoryId } from './valueObjects/categoryId';
import { CategoryIndex } from './valueObjects/categoryIndex';
import { CategoryItemCount } from './valueObjects/categoryItemCount';

import type {
  NoticeCategoryProps,
} from './noticeCategoryEntity';
import type { NoticeCategoryJson } from '@/types/domain/notice/entities/noticeCategoryEntity';

import { Factory } from '@/domain/factory';

/**
 * 掲示板カテゴリファクトリ
 */
export class NoticeCategoryFactory extends Factory<
  NoticeCategoryEntity,
  NoticeCategoryProps,
  NoticeCategoryJson
> {
  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: NoticeCategoryJson, b: NoticeCategoryJson) => {
    const da = a.categoryIndex;
    const db = b.categoryIndex;
    return da > db ? 1 : -1;
  };

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: NoticeCategoryProps): NoticeCategoryEntity {
    return new NoticeCategoryEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: NoticeCategoryJson): NoticeCategoryEntity {
    return this.createPvt({
      categoryId: CategoryId.create(props.categoryId),
      categoryIndex: CategoryIndex.create(props.categoryIndex),
      category: Category.create(props.category),
      categoryItemCount: CategoryItemCount.create(props.categoryItemCount),
    });
  }
}
